import Link from "next/link";
import Fire from "src/app/parrainage/fire.svg";
import FireMobile from "src/app/parrainage/fire_mobile.svg";
import Happy from "src/app/parrainage/happy.svg";
import HappyMobile from "src/app/parrainage/happy_mobile.svg";

import { Button } from "ui/Button";
import { useI18n } from "utils/with-i18n.utils";

export const HowItWorksSection = () => {
  const i18n = useI18n();

  return (
    <div className="flex flex-col gap-y-6 items-center text-white bg-[linear-gradient(180deg,_#7D89FF_0%,_#6974EA_91.4%)] lg:pt-10">
      <div className="hidden gap-x-8 items-center lg:flex">
        <Happy />

        <div className="flex flex-col gap-y-6 text-center">
          <p className="text-2xl font-bold text-white">
            {i18n.t("referral.howItWorksSection.forYou")}
          </p>

          <h1
            className="text-6xl font-extrabold"
            style={{ transform: "skew(-3deg, -4deg)" }}
          >
            {i18n.t("referral.howItWorksSection.freeMonth", {}, { html: true })}
          </h1>

          <p className="mt-1 text-2xl text-white">
            {i18n.t("referral.howItWorksSection.forYou2")}
          </p>
        </div>

        <Fire />
      </div>

      <div className="flex pt-4 lg:hidden">
        <div className="flex flex-col justify-start items-start">
          <HappyMobile />
        </div>

        <div className="flex flex-col gap-y-8">
          <div className="flex justify-center items-center pt-7">
            <p className="text-lg font-bold text-white">
              {i18n.t("referral.howItWorksSection.forYou")}
            </p>
          </div>

          <h1
            className="text-5xl font-extrabold text-center"
            style={{ transform: "skew(-3deg, -4deg)" }}
          >
            {i18n.t("referral.howItWorksSection.freeMonth", {}, { html: true })}
          </h1>

          <div className="flex justify-center items-center pb-8">
            <p className="mt-1 text-lg text-white">
              {i18n.t("referral.howItWorksSection.forYou2")}
            </p>
          </div>
        </div>

        <div className="flex flex-col justify-end items-end">
          <FireMobile />
        </div>
      </div>

      <h2 className="text-xl font-semibold text-white lg:text-3xl">
        {i18n.t("referral.howItWorksSection.question")}
      </h2>

      <div className="grid gap-4 px-6 mb-10 w-full max-w-7xl md:grid-cols-3">
        <div className="relative p-12 text-black bg-white rounded-lg border border-black drop-shadow-[4px_4px_0px_black] lg:px-14">
          <h3 className="mb-2 text-xl font-semibold text-cornflower-blue lg:text-lg">
            {i18n.t("referral.howItWorksSection.step", {
              stepNumber: 1,
            })}
          </h3>

          <p className="mb-2 text-xl font-bold lg:text-2xl">
            {i18n.t(
              "referral.howItWorksSection.step.share.title",
              {},
              { html: true },
            )}
          </p>

          <p className="lg:text-lg">
            {i18n.t(
              "referral.howItWorksSection.step.share.description",
              {},
              { html: true },
            )}
          </p>
        </div>

        <div className="relative p-12 text-black bg-white rounded-lg border border-black drop-shadow-[4px_4px_0px_black] lg:px-14">
          <h3 className="mb-2 text-xl font-semibold text-cornflower-blue lg:text-lg">
            {i18n.t("referral.howItWorksSection.step", {
              stepNumber: 2,
            })}
          </h3>

          <p className="mb-2 text-xl font-bold lg:text-2xl">
            {i18n.t(
              "referral.howItWorksSection.step.profit.title",
              {},
              { html: true },
            )}
          </p>

          <p className="lg:text-lg">
            {i18n.t(
              "referral.howItWorksSection.step.profit.description",
              {},
              { html: true },
            )}
          </p>
        </div>

        <div className="relative p-12 text-black bg-white rounded-lg border border-black drop-shadow-[4px_4px_0px_black] lg:px-14">
          <h3 className="mb-2 text-xl font-semibold text-cornflower-blue lg:text-lg">
            {i18n.t("referral.howItWorksSection.step", {
              stepNumber: 3,
            })}
          </h3>
          <p className="mb-2 text-xl font-bold lg:text-2xl">
            {i18n.t(
              "referral.howItWorksSection.step.limit.title",
              {},
              { html: true },
            )}
          </p>

          <p className="lg:text-lg">
            {i18n.t(
              "referral.howItWorksSection.step.limit.description",
              {},
              { html: true },
            )}
          </p>
        </div>
      </div>

      <Link href="/smartphone">
        <a>
          <Button className="mb-12 text-lg text-black lg:mb-14 lg:text-xl">
            <span>{i18n.t("referral.howItWorksSection.cta")}</span>
          </Button>
        </a>
      </Link>
    </div>
  );
};
